import { render, staticRenderFns } from "./GoalIndexPage.vue?vue&type=template&id=371eaa3f&scoped=true"
import script from "./GoalIndexPage.vue?vue&type=script&lang=js"
export * from "./GoalIndexPage.vue?vue&type=script&lang=js"
import style0 from "./GoalIndexPage.vue?vue&type=style&index=0&id=371eaa3f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371eaa3f",
  null
  
)

export default component.exports